import { useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { MoreToggle } from "../../components/MoreToggle";
import { useProjectCube } from "../../state";
import { usePublicaties, type Publicatie } from "../../state/publicaties";
import { afstand, datum } from "./bekendmakingenFormat";
import { A, Info, KV, SubHeader } from "./util";

const TOON = 5;

const Regel = ({ p }: { p: Publicatie }) => (
  <div className="py-1">
    <A href={p.url}>{p.titel}</A>
    <div className="text-sm text-gray-600">
      {[p.creator, datum(p.gepubliceerdOp), afstand(p.afstandMeter)].filter(Boolean).join(" · ")}
    </div>
  </div>
);

/**
 * Officiële bekendmakingen rond het project, uit het publicatieregister van de
 * omgevingsmonitor. Alleen zichtbaar binnen een project: buiten die context is
 * er geen perceel om een straal omheen te leggen.
 *
 * Individuele omgevingsvergunningen blijven aan de serverkant buiten beeld —
 * landelijk zijn dat er ~1.000 per dag en ze verdringen het beleid dat er hier
 * toe doet.
 */
export const Bekendmakingen = () => {
  const [open, setOpen] = useState(false);
  const projectId = useProjectCube((s) => s.projectId);
  const [state, publicaties, load] = usePublicaties(
    useShallow((s) => [s.state, s.publicaties, s.load])
  );

  useEffect(() => {
    if (projectId != null) load(projectId);
  }, [projectId, load]);

  // Geen project, een storing bij de monitor, of eenvoudigweg niets in de
  // buurt: in alle drie de gevallen is een lege sectie eerlijker dan een
  // foutmelding over een bron die de lezer niet kent.
  if (projectId == null || state === "error" || !publicaties?.length) return null;

  const zichtbaar = open ? publicaties : publicaties.slice(0, TOON);
  return (
    <>
      <SubHeader>Bekendmakingen</SubHeader>
      <Info as="dl">
        <KV k={`Recent gepubliceerd (${publicaties.length})`}>
          {zichtbaar.map((p) => (
            <Regel key={p.publicatieId} p={p} />
          ))}
          {publicaties.length > TOON && <MoreToggle open={open} setOpen={setOpen} />}
        </KV>
      </Info>
    </>
  );
};
